import React, { useEffect, useState } from "react";
import { Alert, Card, CardContent, Stack, Typography } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { Link } from "react-router-dom";

import { listNetworkPortalOffers } from "../../services/coreNetworkPortal";
import {
  NetworkPortalLayout,
  PortalAuthState,
  PortalLoading,
  StatusChip,
  TalentPortalEmptyState,
  formatCurrency,
  formatDateTime,
  safeArray,
  toTitleCase,
  useNetworkPortalSession,
} from "./networkPortalShared";

export default function NetworkPortalOfferList() {
  const { member, loading, error } = useNetworkPortalSession();
  const [offers, setOffers] = useState([]);
  const [pageError, setPageError] = useState("");

  useEffect(() => {
    if (!member) return;
    let active = true;

    async function loadOffers() {
      try {
        setPageError("");
        const response = await listNetworkPortalOffers();
        if (active) {
          setOffers(safeArray(response.offers));
        }
      } catch (loadError) {
        if (active) {
          setPageError(loadError?.response?.data?.message || loadError.message || "Unable to load offers.");
        }
      }
    }

    loadOffers();
    return () => {
      active = false;
    };
  }, [member]);

  if (loading) return <PortalLoading />;
  if (!member) return <PortalAuthState error={error} />;

  return (
    <NetworkPortalLayout title="Offers" subtitle="Available work offers for your Core Network profile." member={member}>
      <Stack spacing={2.5}>
        {pageError ? <Alert severity="error">{pageError}</Alert> : null}
        {offers.length ? offers.map((offer) => (
          <Card key={offer.id} component={Link} to={`/talent/offers/${offer.id}`} elevation={0} sx={{ border: "1px solid #d9e2ec", borderRadius: 3, textDecoration: "none", color: "inherit" }}>
            <CardContent>
              <Stack spacing={1}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {offer.workRequest?.title || `Offer #${offer.id}`}
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  <StatusChip value={offer.status} />
                  <Typography variant="caption" color="text.secondary">{toTitleCase(offer.workRequest?.requestType)}</Typography>
                  <Typography variant="caption" color="text.secondary">{formatCurrency(offer.quotedPrice, offer.currency)}</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  Due {formatDateTime(offer.workRequest?.deadlineAt)} | Expires {formatDateTime(offer.expiresAt)}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        )) : (
          <TalentPortalEmptyState icon={<LocalOfferIcon fontSize="small" />} title="No offers waiting" description="No offers are waiting for you right now." />
        )}
      </Stack>
    </NetworkPortalLayout>
  );
}
